import PropTypes from 'prop-types'
import { Caption5 } from '../../styled/typography/typography'
import useLexicon from '../../../hooks/useLexicon'

const LevelCaption = ({ metaData }) => {
  const lexicon = useLexicon()

  return(
    <Caption5 color={metaData.master_course.color}>
      {metaData.master_course.abbreviation} /
      {metaData.course.name} /
      {`${!metaData.level.mastery
        ? `${lexicon.level} ${metaData.level.number}`
        : `Mastery ${lexicon.level}`
      }`}
    </Caption5>
  )
}

LevelCaption.propTypes = {
  metaData: PropTypes.object.isRequired
}

export default LevelCaption
